/* eslint-disable no-shadow */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import {
    fetchFilterTransactions,
    setEditForm,
    transactionUpdate
} from '../features/filter/filterTransactions';
import {
    addToAllTransactions,
    createTransaction,
    editInActive,
    updateAllTransation,
    updateTransaction
} from '../features/transactions/transactionsSlice';

function Form() {
    const [name, setName] = useState('');
    const [type, setType] = useState('');
    const [amount, setAmount] = useState('');
    const [editMode, setEditMode] = useState(false);

    const dispatch = useDispatch();
    const { editTransaction } = useSelector((state) => state.transaction);
    const { filter } = useSelector((state) => state);

    useEffect(() => {
        if (editTransaction?.id) {
            setEditMode(true);
            const { name, type, amount } = editTransaction;
            setName(name);
            setType(type);
            setAmount(amount);
        } else {
            reset();
        }
    }, [editTransaction]);

    const handleCreate = (e) => {
        e.preventDefault();
        dispatch(
            createTransaction({
                name,
                type,
                amount
            })
        );
        dispatch(
            addToAllTransactions({
                name,
                type,
                amount
            })
        );
        dispatch(
            fetchFilterTransactions({ type: filter.type, search: filter.search, page: filter.page })
        );
        reset();
    };

    const handleUpdate = (e) => {
        e.preventDefault();
        dispatch(
            updateTransaction({
                id: editTransaction.id,
                data: {
                    name,
                    type,
                    amount
                }
            })
        );
        dispatch(
            transactionUpdate({
                id: editTransaction.id,
                data: {
                    name,
                    type,
                    amount,
                    id: editTransaction.id
                }
            })
        );
        dispatch(
            updateAllTransation({
                id: editTransaction.id,
                data: {
                    name,
                    type,
                    amount,
                    id: editTransaction.id
                }
            })
        );
        dispatch(editInActive());
        dispatch(setEditForm(false));
        reset();
        setEditMode(false);
    };

    const reset = () => {
        setName('');
        setType('');
        setAmount('');
    };

    const handleCancleEdit = () => {
        dispatch(editInActive());
        dispatch(setEditForm(false));
        reset();
        setEditMode(false);
    };

    return (
        <div className="form">
            {/* <h3>{filter.editForm ? 'Update transaction' : 'Add new transaction'}</h3>
            Add new transaction</h3> */}

            <form onSubmit={editMode ? handleUpdate : handleCreate}>
                {/* <div className="form-group">
                    <label>Name</label>

                    <input
                        type="text"
                        name="name"
                        placeholder="Enter Name"
                        onChange={(e) => setName(e.target.value)}
                        value={name}
                        required
                    />
                </div> */}
                <div className="mb-6">
                    <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-90">
                        Title
                    </label>
                    <input
                        type="text"
                        name="name"
                        placeholder="Enter Title"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        required
                        onChange={(e) => setName(e.target.value)}
                        value={name}
                    />
                </div>

                <div className="form-group radio">
                    {/* <label>Type</label> */}
                    <div className="radio_group">
                        <input
                            type="radio"
                            value="income"
                            name="type"
                            checked={type === 'income'}
                            onChange={(e) => setType('income')}
                            required
                            className="accent-violet-500"
                        />
                        <label
                            htmlFor="orange-radio"
                            className="ml-2 text-m font-medium text-green-900"
                        >
                            Income
                        </label>
                    </div>
                    <div className="radio_group">
                        <input
                            type="radio"
                            value="expense"
                            name="type"
                            checked={type === 'expense'}
                            onChange={(e) => setType('expense')}
                            required
                            className="accent-pink-500"
                        />
                        <label
                            htmlFor="orange-radio"
                            className="ml-2 text-m font-medium text-green-900"
                        >
                            Expense
                        </label>
                    </div>
                </div>

                {/* <div className="form-group">
                    <label>Amount</label>
                    <input
                        type="number"
                        placeholder="300"
                        name="amount"
                        onChange={(e) => setAmount(e.target.value)}
                        value={amount}
                        required
                    />
                </div> */}
                <div className="mb-6">
                    <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-90">
                        Amount
                    </label>
                    <input
                        type="number"
                        placeholder="enter amount"
                        name="amount"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        required
                        onChange={(e) => setAmount(e.target.value)}
                        value={amount}
                    />
                </div>

                {/* <button className="btn" type="submit">
                    {editMode ? 'Update Transaction' : 'Add Transaction'}
                </button> */}
                <button className="bg-transparent hover:bg-green-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-green-500 hover:border-transparent rounded m-6">
                    {editMode ? 'Update Transaction' : 'Add Transaction'}
                </button>
            </form>

            {editMode && (
                <button onClick={handleCancleEdit} className="btn cancel_edit">
                    Cancel Edit
                </button>
            )}
        </div>
    );
}

export default Form;
